import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Tag } from '@beef/ui-kit';
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var ServiceHeader = /*#__PURE__*/memo(function (_ref) {
  var img = _ref.img,
    tag = _ref.tag;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('header-img'),
    style: {
      backgroundImage: "url('".concat(img || '', "')")
    },
    "data-t-id": "components-ServiceHeader"
  }, tag && /*#__PURE__*/React.createElement(Tag, _extends({}, tag, {
    rightSideNode:
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    React.createElement(React.Fragment, null, tag.icon && /*#__PURE__*/React.createElement("img", {
      alt: "icon",
      className: cn('icon'),
      src: tag.icon
    }))
  })));
});